export const myDashboardActionTypes = {
    STORE_MY_REPORT: "STORE_MY_REPORT",
    STORE_TEAM_REPORT: "STORE_TEAM_REPORT",
    STORE_DASHBOARD_GOALS: "STORE_DASHBOARD_GOALS",
}